import {extendTheme} from '@salesforce/retail-react-app/app/components/shared/ui';

import {overrides as baseOverrides} from '@amblique/base/app/theme';
import kingStyles from '@amblique/king-living/app/theme/foundations/styles';
import space from '@amblique/king-living/app/theme/foundations/space';
import sizes from '@amblique/king-living/app/theme/foundations/sizes';
import typography from '@amblique/king-living/app/theme/foundations/typography';
import Alert from '@amblique/king-living/app/theme/components/base/alert';
import Badge from '@amblique/king-living/app/theme/components/base/badge';
import Button from '@amblique/king-living/app/theme/components/base/button';
import Checkbox from '@amblique/king-living/app/theme/components/base/checkbox';
import Link from '@amblique/king-living/app/theme/components/base/link';
import NumberInput from '@amblique/king-living/app/theme/components/base/number-input';
import Radio from '@amblique/king-living/app/theme/components/base/radio';
import RangeSlider from '@amblique/king-living/app/theme/components/base/range-slider';
import Select from '@amblique/king-living/app/theme/components/base/select';
import Slider from '@amblique/king-living/app/theme/components/base/slider';
import Swiper from '@amblique/king-living/app/theme/components/shared/swiper';
import Tag from '@amblique/king-living/app/theme/components/base/tag';
import Textarea from '@amblique/king-living/app/theme/components/base/textarea';
import ToggleCard from '@amblique/king-living/app/theme/components/base/toggle-card';
import AddressAutocompleteUI from '@amblique/king-living/app/theme/components/project/address-autocomplete-ui';
import AddToCartUpsell from '@amblique/king-living/app/theme/components/project/add-to-cart-upsell';
import AnimatedHeroCopy from '@amblique/king-living/app/theme/components/project/animated-hero-copy';
import BlogHeading from '@amblique/king-living/app/theme/components/project/blog-heading';
import BazaarvoiceInlineRating from '@amblique/king-living/app/theme/components/project/bazaarvoice-inline-rating';
import Breadcrumbs from '@amblique/king-living/app/theme/components/project/breadcrumbs';
import Callout from '@amblique/king-living/app/theme/components/project/callout';
import CareersJobBoard from '@amblique/king-living/app/theme/components/project/careers-job-board';
import CheckboxFilterPartial from '@amblique/king-living/app/theme/components/project/checkbox-filter-partial';
import CheckoutPage from '@amblique/king-living/app/theme/components/project/checkoutPage';
import CheckoutConfirmationPage from '@amblique/king-living/app/theme/components/project/checkoutConfirmationPage';
import Comparison from '@amblique/king-living/app/theme/components/project/comparison';
import DoubleImageCarousel from '@amblique/king-living/app/theme/components/project/double-image-carousel';
import EditorialCopy from '@amblique/king-living/app/theme/components/project/editorial-copy';
import Field from '@amblique/king-living/app/theme/components/project/field';
import FinishedGoodView from '@amblique/king-living/app/theme/components/project/finished-good-view';
import FilterBar from '@amblique/king-living/app/theme/components/project/filter-bar';
import TagsFilterFlyout from '@amblique/king-living/app/theme/components/project/tags-filter-flyout';
import FormAuth from '@amblique/king-living/app/theme/components/project/form-auth';
import FullHeaderHero from '@amblique/king-living/app/theme/components/project/full-header-hero';
import FullScreenImageGallery from '@amblique/king-living/app/theme/components/project/full-screen-image-gallery';
import CylindoViewer from '@amblique/king-living/app/theme/components/project/cylindo-viewer';
import ImageGallery from '@amblique/king-living/app/theme/components/project/image-gallery';
import ProductImageGallery from '@amblique/king-living/app/theme/components/project/product-image-gallery';
import Header from '@amblique/king-living/app/theme/components/project/header';
import HeaderHero from '@amblique/king-living/app/theme/components/project/header-hero';
import Hotspot from '@amblique/king-living/app/theme/components/project/hot-spot';
import HotspotContent from '@amblique/king-living/app/theme/components/project/hotspot-content';
import IconExplainer from '@amblique/king-living/app/theme/components/project/icon-explainer';
import ImageTiles from '@amblique/king-living/app/theme/components/project/image-tiles';
import ImageZoomModal from '@amblique/king-living/app/theme/components/project/image-zoom-modal';
import JobDetailsPage from '@amblique/king-living/app/theme/components/project/job-details-page';
import LazyLoadGrid from '@amblique/king-living/app/theme/components/project/lazy-load-grid';
import MegaMenu from '@amblique/king-living/app/theme/components/project/mega-menu';
import MobileAnchoredTooltip from '@amblique/king-living/app/theme/components/project/mobile-anchored-tooltip';
import ModularPreview from '@amblique/king-living/app/theme/components/project/modular-preview';
import Newsletter from '@amblique/king-living/app/theme/components/project/newsletter';
import Account from '@amblique/king-living/app/theme/components/project/account';
import AccountNav from '@amblique/king-living/app/theme/components/project/account-nav';
import PageAuth from '@amblique/king-living/app/theme/components/project/page-auth';
import PageNotFound from '@amblique/king-living/app/theme/components/project/page-not-found';
import PasswordRequirements from '@amblique/king-living/app/theme/components/project/password-requirements';
import Progress from '@amblique/king-living/app/theme/components/project/process';
import ProductCard from '@amblique/king-living/app/theme/components/project/product-card';
import ProductDetail from '@amblique/king-living/app/theme/components/project/product-detail';
import ProductStockIndicator from '@amblique/king-living/app/theme/components/project/product-stock-indicator';
import ProductList from '@amblique/king-living/app/theme/components/project/product-list';
import ProductRange from '@amblique/king-living/app/theme/components/project/product-range';
import RangeDownloads from '@amblique/king-living/app/theme/components/project/range-downloads';
import RangeFilterTags from '@amblique/king-living/app/theme/components/project/range-filter-tags';
import RangeProductTile from '@amblique/king-living/app/theme/components/project/range-product-tile';
import ProjectButton from '@amblique/king-living/app/theme/components/project/project-button';
import QuantityPicker from '@amblique/king-living/app/theme/components/project/quantity-picker';
import RangeSliderFilterPartial from '@amblique/king-living/app/theme/components/project/range-slider-filter-partial';
import CartFlyout from '@amblique/king-living/app/theme/components/project/cart-flyout';
import BuyNowPayLaterMessaging from '@amblique/king-living/app/theme/components/project/buy-now-pay-later-messaging';
import CheckoutOrderSummary from '@amblique/king-living/app/theme/components/project/checkout-order-summary';
import ReviewSection from '@amblique/king-living/app/theme/components/project/review-section';
import ConfigurationSelector from '@amblique/king-living/app/theme/components/project/configuration-selector';
import CustomizeSteps from '@amblique/king-living/app/theme/components/project/customize-steps';
import CustomizeStepsInline from '@amblique/king-living/app/theme/components/project/customize-steps-inline';
import SimpleCoverStep from '@amblique/king-living/app/theme/components/project/simple-cover-step';
import SwatchOptionCard from '@amblique/king-living/app/theme/components/project/swatch-option-card';
import CoverSwatchGrid from '@amblique/king-living/app/theme/components/project/cover-swatch-grid';
import ViewDetails from '@amblique/king-living/app/theme/components/project/view-details';
import SearchForm from '@amblique/king-living/app/theme/components/project/search-form';
import SearchIdlePanel from '@amblique/king-living/app/theme/components/project/search-idle-panel';
import SearchTypeaheadPanel from '@amblique/king-living/app/theme/components/project/search-typeahead-panel';
import SearchModal from '@amblique/king-living/app/theme/components/project/search-modal';
import ShopButton from '@amblique/king-living/app/theme/components/project/shop-button';
import ShopTheLook from '@amblique/king-living/app/theme/components/project/shop-the-look';
import ShopTheLookBlock from '@amblique/king-living/app/theme/components/project/shop-the-look-block';
import Showroom from '@amblique/king-living/app/theme/components/project/showroom';
import ShowroomSelectionPopup from '@amblique/king-living/app/theme/components/project/showroom-selection-popup';
import ShowroomListHeader from '@amblique/king-living/app/theme/components/project/showroom-list-header';
import Showrooms from '@amblique/king-living/app/theme/components/project/showrooms';
import ContactSection from '@amblique/king-living/app/theme/components/project/contact-section';
import SingleShopTheLook from '@amblique/king-living/app/theme/components/project/single-shop-the-look';
import InlineSwatchCard from '@amblique/king-living/app/theme/components/project/inline-swatch-card';
import LocaleSelector from '@amblique/king-living/app/theme/components/project/locale-selector';
import SwatchCarousel from '@amblique/king-living/app/theme/components/project/swatch-carousel';
import SwatchListRow from '@amblique/king-living/app/theme/components/project/swatch-list-row';
import UGCCarousel from '@amblique/king-living/app/theme/components/project/ugc-carousel';
import VideoCarousel from '@amblique/king-living/app/theme/components/project/video-carousel';
import VideoCarouselWithCopyIcons from '@amblique/king-living/app/theme/components/project/video-carousel-with-copy-icons';
import InstockProductTile from '@amblique/king-living/app/theme/components/project/instock-product-tile';
import OptionalAddOns from '@amblique/king-living/app/theme/components/project/optional-add-ons';
import ProtectYourCover from '@amblique/king-living/app/theme/components/project/protect-your-cover';
import StandaloneViewDetailsModal from '@amblique/king-living/app/theme/components/project/standalone-view-details-modal';
import WantItSooner from '@amblique/king-living/app/theme/components/project/want-it-sooner';
import PdpDeliveryAvailability from '@amblique/king-living/app/theme/components/project/pdp-delivery-availability';
import WhySignUp from '@amblique/king-living/app/theme/components/project/why-sign-up';
import {contentfulStyles} from '@amblique/king-living/app/theme/contentful';

const {components: baseComponents, ...baseExtensions} = baseOverrides;

export const overrides = {
  ...baseExtensions,
  styles: {
    ...(baseExtensions.styles || {}),
    global: {
      ...(baseExtensions.styles?.global || {}),
      ...kingStyles.global,
    },
  },
  space,
  sizes,
  ...typography,

  components: {
    ...baseComponents,
    ...contentfulStyles,

    // Base Components
    Alert,
    Badge,
    Button,
    Checkbox,
    Link,
    NumberInput,
    Radio,
    RangeSlider,
    Select,
    Slider,
    Tag,
    Textarea,
    ToggleCard,

    // Project Components
    AddressAutocompleteUI,
    AddToCartUpsell,
    AnimatedHeroCopy,
    BlogHeading,
    BazaarvoiceInlineRating,
    Breadcrumbs,
    Callout,
    CareersJobBoard,
    CheckoutPage,
    CheckoutConfirmationPage,
    CheckboxFilterPartial,
    Comparison,
    DoubleImageCarousel,
    EditorialCopy,
    Field,
    FinishedGoodView,
    FilterBar,
    TagsFilterFlyout,
    FormAuth,
    FullHeaderHero,
    FullScreenImageGallery,
    CylindoViewer,
    ImageGallery,
    ProductImageGallery,
    Header,
    HeaderHero,
    Hotspot,
    HotspotContent,
    IconExplainer,
    ImageTiles,
    ImageZoomModal,
    InlineSwatchCard,
    JobDetailsPage,
    LazyLoadGrid,
    LocaleSelector,
    MegaMenu,
    MobileAnchoredTooltip,
    ModularPreview,
    Newsletter,
    PageAuth,
    PageNotFound,
    Account,
    AccountNav,
    PasswordRequirements,
    Progress,
    ProductCard,
    ProductDetail,
    ProductStockIndicator,
    ProductList,
    ProductRange,
    RangeDownloads,
    RangeFilterTags,
    RangeProductTile,
    ProjectButton,
    QuantityPicker,
    RangeSliderFilterPartial,
    CartFlyout,
    BuyNowPayLaterMessaging,
    CheckoutOrderSummary,
    ReviewSection,
    ConfigurationSelector,
    CustomizeSteps,
    CustomizeStepsInline,
    SimpleCoverStep,
    SwatchOptionCard,
    CoverSwatchGrid,
    ViewDetails,
    SearchForm,
    SearchIdlePanel,
    SearchTypeaheadPanel,
    SearchModal,
    ShopButton,
    ShopTheLook,
    ShopTheLookBlock,
    Showroom,
    ShowroomSelectionPopup,
    ShowroomListHeader,
    Showrooms,
    ContactSection,
    SingleShopTheLook,
    SwatchCarousel,
    SwatchListRow,
    UGCCarousel,
    VideoCarousel,
    VideoCarouselWithCopyIcons,
    InstockProductTile,
    OptionalAddOns,
    protectYourCover: ProtectYourCover,
    StandaloneViewDetailsModal,
    WantItSooner,
    PdpDeliveryAvailability,
    WhySignUp,
    Swiper,
  },
};

export default extendTheme(overrides);
